import { render, staticRenderFns } from "./TripartiteIndex.vue?vue&type=template&id=05f9183c&scoped=true"
import script from "./TripartiteIndex.vue?vue&type=script&lang=js"
export * from "./TripartiteIndex.vue?vue&type=script&lang=js"
import style0 from "./TripartiteIndex.vue?vue&type=style&index=0&id=05f9183c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9183c",
  null
  
)

export default component.exports